import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';
import { ROUTE_CONFIG } from '../config/roles';

// Importar componentes de páginas
import Dashboard from '../pages/Dashboard';
import DashboardDeals from '../pages/DashboardDeals';
import Users from '../pages/Usuarios';
import Reports from '../pages/Reports';
import Eventos from '../pages/Eventos';
import Accesos from '../pages/Accesos';
import Configuracion from '../pages/Configuracion';
import Puertas from '../pages/Puertas';
import Funcionarios from '../pages/Funcionarios';
import CallCenter from '../pages/CallCenter';
import Leads from '../pages/Leads';
import LeadDetail from '../pages/LeadDetail';
import Deals from '../pages/Deals';
import DealDetail from '../pages/DealDetail';
import Contacts from '../pages/Contacts';
import Imports from '../pages/Imports';
import Debug from '../pages/Debug';

// Mapeo de componentes
const componentMap: Record<string, React.ComponentType<any>> = {
  Dashboard,
  DashboardDeals,
  Users,
  Reports,
  Eventos,
  Accesos,
  Configuracion,
  Puertas,
  Funcionarios,
  CallCenter,
  Leads,
  LeadDetail,
  Deals,
  DealDetail,
  Contacts,
  Imports,
  Debug,
};

interface ProtectedRoutesProps {
  children?: React.ReactNode;
}

export const ProtectedRoutes: React.FC<ProtectedRoutesProps> = ({ children }) => {
  return (
    <Routes>
      {children}
      
      {/* Redirección por defecto al dashboard */}
      <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
      
      {/* Rutas dinámicas basadas en configuración */}
      {ROUTE_CONFIG.map((route) => {
        const Component = componentMap[route.component];
        
        if (!Component) {
          console.warn(`Componente ${route.component} no encontrado para la ruta ${route.path}`);
          return null;
        }

        return (
          <Route
            key={route.path}
            path={route.path}
            element={
              <ProtectedRoute
                allowedRoles={route.allowedRoles}
                requiredPermissions={route.requiredPermissions}
                routePath={route.path}
              >
                <Component />
              </ProtectedRoute>
            }
          />
        );
      })}
    </Routes>
  );
};
